import { Icon } from '@zapier/design-system';
import React from 'react';
import { Link, Button } from 'react-aria-components';

const root = "_root_7zs2k_1";
const styles = {
	root: root
};

function isLinkProps(props) {
  return typeof props.href === "string";
}
const ActionChip = (props) => {
  const { href, hrefLang, isDisabled, onPress, size, target } = props;
  if (isLinkProps(props)) {
    return React.createElement(Link, { className: styles.root, "data-size": size, "data-zds": true, href, hrefLang, isDisabled, onPress, target }, (linkRenderProps) => typeof props.children === "function" ? props.children(linkRenderProps) : props.children);
  }
  return React.createElement(Button, { className: styles.root, "data-size": size, "data-zds": true, isDisabled, onPress }, (buttonRenderProps) => typeof props.children === "function" ? props.children(buttonRenderProps) : props.children);
};
const ActionChipIcon = ({ name }) => React.createElement(Icon, { name });

export { ActionChip, ActionChipIcon };
//# sourceMappingURL=ActionChip.es.js.map
